"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConstant = useConstant;
const react_1 = require("react");
/**
 * A hook to get a constant reference to some value, which may be more complex than just a primitive
 * Similar to useMemo, but with guarantee that the initialiser is executed exactly once
 *
 * @param value initialiser for the value, called exactly once
 * @returns value initialised
 */
function useConstant(value) {
    const ref = (0, react_1.useRef)();
    if (ref.current === undefined) {
        ref.current = { value: value() };
    }
    return ref.current.value;
}
//# sourceMappingURL=use_constant.js.map